export * from './paginator/paginator.component';
